import Cookies from 'universal-cookie';
import { head, get } from 'lodash';
import { CompaniesType, CompanyType } from 'types/companiesType';

const cookies = new Cookies();

const COOKIES_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
const USER_TOKEN_ID = 'id_token';
const TT_REGION_IDS = 'tt-region-ids';
const TT_REGION_SEPARATOR = ',';
const TT_COMPANIES = 'tt-companies';
const TT_COOKIE_DEFAULT_PATH = '/';
const TT_APP_TOKEN = 'tt-token';
const EMAIL = 'email';
const CODE_VERIFIER = 'code-verifier';

const DEFAULT_COOKIE_OPTION = {
  path: TT_COOKIE_DEFAULT_PATH,
  domain: COOKIES_DOMAIN,
};

export const getTokenExpireDay = (company: CompanyType): Date => {
  const expiredAt = get(company, 'expired_at', '');
  return new Date(expiredAt);
};

export const setUserIdTokenToLocalStorage = (idToken: string) => {
  localStorage.setItem(USER_TOKEN_ID, idToken);
};

export const getUserIdTokenFromLocalStorage = () => {
  return localStorage.getItem(USER_TOKEN_ID);
};

export const setRegionIdsToLocalStorage = (regionIds: string[]) => {
  localStorage.setItem(TT_REGION_IDS, regionIds.join(TT_REGION_SEPARATOR));
};

export const getRegionIdsFromLocalStorage = (): string[] => {
  const regionIds = localStorage.getItem(TT_REGION_IDS);
  return regionIds.split(TT_REGION_SEPARATOR);
};

export const removeRegionIdsFromLocalStorage = () => {
  localStorage.removeItem(TT_REGION_IDS);
};

export const setCompaniesToCookie = (companies: CompaniesType) => {
  const firstCompany = head(companies);
  const expires = getTokenExpireDay(firstCompany);
  cookies.set(TT_COMPANIES, JSON.stringify(companies), {
    ...DEFAULT_COOKIE_OPTION,
    expires,
  });
};

export const getCompaniesFromCookie = (): CompaniesType => {
  const companies = cookies.get(TT_COMPANIES) || [];
  return companies;
};

export const removeCompaniesCookie = () => {
  cookies.remove(TT_COMPANIES, DEFAULT_COOKIE_OPTION);
};

export const setAppTokenToCookie = (company: CompanyType) => {
  const expires = getTokenExpireDay(company);
  cookies.set(TT_APP_TOKEN, JSON.stringify(company), {
    ...DEFAULT_COOKIE_OPTION,
    expires,
  });
};

export const getAppTokenFromCookie = (): CompanyType => {
  const company = cookies.get(TT_APP_TOKEN);
  return company;
};

export const removeAppTokenCookie = () => {
  cookies.remove(TT_APP_TOKEN, DEFAULT_COOKIE_OPTION);
};

export const setEmailToLocalStorage = (email: string) => {
  localStorage.setItem(EMAIL, email);
};

export const getEmailFromLocalStorage = () => localStorage.getItem(EMAIL);

export const removeEmailFromLocalStorage = () => localStorage.removeItem(EMAIL);

export const getCodeVerifierFromLocalStorage = (): string | null => {
  return localStorage.getItem(CODE_VERIFIER);
};

export const setCodeVerifierToLocalStorage = (verifyCode: string) => {
  return localStorage.setItem(CODE_VERIFIER, verifyCode);
};

export const removeCodeVerifierFromLocalStorage = () =>
  localStorage.removeItem(CODE_VERIFIER);

export const clearStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};

export const clearSessionFromStorageAndCookies = () => {
  clearStorage();
  removeCompaniesCookie();
  removeAppTokenCookie();
};
